<script>
import {mapActions} from "vuex";
import FormModal from '@/driver/pages/masters/recycle_disposal_methods/_FormModal.vue'

export default {
  name: "DisposalMethodModal",
  components: {FormModal},
  props: {},
  data() {
    return {
      openModal: false,
      openRegisterModal: false,
      conditions: {
        name: null,
        primary_after_disposal_method_id: null,
        after_disposal_method_ids: [],
        without_invisible: true,
      },
      page: 1,
      perPage: 50,
      totalVisible: 7,
      pagination: {
        current_page: 1,
        total_count: 0,
      },
      headers: [
        { value: 'code', text: 'コード', width: '15%' },
        { value: 'name', text: '処分方法名', width: '15%' },
        { value: 'primary_after_disposal_method_name', text: '主たる処分方法', width: '18%' },
        { value: 'after_disposal_method_names', text: '処分１/処分２/処分３/処分４', width: '25%' },
        { value: 'sort_priority', text: '表示順', align: 'right', width: '10%' },
        { value: 'updated_at', text: 'データ更新日時', width: '17%' },
      ],
      items: [],
      selectedItem: null,
      selectedRow: null,
      afterRecycleMethods: [],
    }
  },
  computed: {},
  watch: {
    openModal (val) {
      Object.assign(this.$data.conditions, this.$options.data().conditions);
      this.items = [];
      this.selectedItem = null;
      if (this.selectedRow) {
        this.selectedRow.select(false);
        this.selectedRow = null;
      }
      if (val) {
        this.searchButtonClick();
      }
    }
  },
  created() {
    this.fetchAfterRecycleMethods().then((content) => {
      this.afterRecycleMethods = content.after_recycle_methods;
    });
  },
  methods: {
    ...mapActions('DriverMasterRecycleDisposalMethod', {
      fetchRecycleDisposalMethods: 'index',
    }),
    ...mapActions("DriverMasterSearchAfterRecycleMethod", {
      fetchAfterRecycleMethods: "index"
    }),
    searchButtonClick () {
      this.page = 1;
      this.search();
    },

    addButtonClick () {
      this.openRegisterModal = true;
    },

    selectButtonClick () {
      this.$emit("selected", this.selectedItem);
      this.closeModal();
    },

    nameClearCallback () {
      this.conditions.name = null;
      this.searchButtonClick();
    },

    /**
     * 排出事業者　行選択イベント
     * @param item
     * @param row
     */
    rowClickEvent(item, row) {
      this.selectedItem = item
      this.selectedRow = row
      row.select(true)
    },
    /**
     * 排出事業者　行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("selected", row.item);
      this.closeModal();
    },

    pageChangeCallback () {
      this.search();
    },

    closeModal() {
      this.openModal = false
    },

    /**
     * 追加・詳細・編集モーダル 閉じるコールバック
     */
    closeModalCallback () {
      this.openRegisterModal = false;
    },
    /**
     * 追加・編集モーダル 登録完了コールバック
     */
    registerCallback () {
      this.page = 1;
      this.search();
      this.closeModalCallback();
      this.$emit("reload")
    },

    search() {
      const params = {
        ...this.conditions,
        page: this.page,
        limit: this.perPage,
        useState: false,
      }
      this.fetchRecycleDisposalMethods(params).then((content) => {
        this.items = content.recycle_disposal_methods;
        this.pagination = content.pagination;
        this.scrollToTop();
      })
    },
    scrollToTop() {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
  },
}
</script>

<template>
  <div>
    <v-dialog
      v-model="openModal"
      persistent
      scrollable
      width="1200"
      @keydown.esc="closeModal"
      @close="closeModal"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          選択
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          flat
        >
          <v-toolbar-title>
            処分方法
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-title class="pa-2 my-1">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header class="panel-header-color panel-selectable">
                <strong>
                  <v-icon class="panel-header-color">
                    mdi-magnify
                  </v-icon>
                  &nbsp;条件を指定して検索
                </strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="conditions.name"
                          class="search-font"
                          clearable
                          dense
                          hide-details
                          label="処分方法名"
                          outlined
                          persistent-placeholder
                          placeholder="部分一致で検索"
                          rounded
                          @blur="searchButtonClick"
                          @click:clear="nameClearCallback"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-autocomplete
                          v-model="conditions.primary_after_disposal_method_id"
                          :items="afterRecycleMethods"
                          clearable
                          dense
                          hide-details
                          label="主たる処分方法"
                          outlined
                          rounded
                          persistent-placeholder
                          @change="searchButtonClick"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-autocomplete
                          v-model="conditions.after_disposal_method_ids"
                          :items="afterRecycleMethods"
                          clearable
                          dense
                          hide-details
                          label="処分方法"
                          outlined
                          rounded
                          multiple
                          persistent-placeholder
                          @change="searchButtonClick"
                        />
                      </v-col>
                      <v-col v-if="false" cols="12" md="4">
                        <v-checkbox
                          v-model="conditions.without_invisible"
                          dense
                          label="非表示を表示しない"
                          persistent-hint
                          class="mt-2"
                          @change="searchButtonClick"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="searchButtonClick">
                      <v-icon>mdi-magnify</v-icon>&nbsp;検索
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-title>
        <v-card-title class="pa-2 my-1">
          <v-spacer />
          <div>
            <v-btn
              color="primary"
              @click="addButtonClick"
            >
              新規追加&nbsp;<v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pa-1 card-layer" style="height: 45vh;">
          <v-sheet class="mt-5 mb-5" rounded>
            <v-data-table
              :headers="headers"
              :items="items"
              disable-pagination
              :items-per-page="-1"
              disable-sort
              hide-default-footer
              fixed-header
              single-select
              @click:row="rowClickEvent"
              @dblclick:row="rowDoubleClickEvent"
            >
              <!-- コード -->
              <template v-slot:[`item.code`]="{ item }">
                {{ item.code }}
              </template>
              <!-- /コード -->

              <template v-slot:[`item.name`]="{ item }">
                <div :title="item.name" class="line-clamp one-clamp">{{ item.name }}</div>
              </template>

              <template v-slot:[`item.primary_after_disposal_method_name`]="{ item }">
                <div
                  :title="item.primary_after_disposal_method_name"
                  class="line-clamp one-clamp"
                >
                  {{ item.primary_after_disposal_method_name }}
                </div>
              </template>

              <template v-slot:[`item.after_disposal_method_names`]="{ item }">
                <div
                  :title="item.after_disposal_method_names"
                  class="line-clamp one-clamp"
                >
                  {{ item.after_disposal_method_names }}
                </div>
              </template>

              <template v-slot:[`item.updated_at`]="{ item }">
                {{ item.updated_at | unix_datetime_format }}
              </template>

            </v-data-table>
          </v-sheet>

          <!-- ページャ -->
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                next-icon="mdi-menu-right"
                prev-icon="mdi-menu-left"
                @input="pageChangeCallback"
              />
            </v-col>
          </v-row>
          <!-- ページャ -->

        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeModal">閉じる</v-btn>
          <v-btn color="primary" @click="selectButtonClick">選択</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <form-modal
      :enable-dialog="openRegisterModal"
      @close="closeModalCallback"
      @register="registerCallback"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
